var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.bonusLevels.length
    ? _c(
        "div",
        { attrs: { "data-qa": "lpu_loyalty_program" } },
        [
          _vm.useLabel
            ? _c(_setup.LpuLoyaltyProgramLabel, {
                attrs: {
                  "min-percent": _setup.minPercent,
                  "max-percent": _setup.maxPercent,
                  "welcome-bonus-amount": _vm.welcomeBonusAmount,
                },
                on: {
                  click: function ($event) {
                    _setup.isOpenedLpuLoyaltyProgramInfo = true
                  },
                },
              })
            : _vm.useBadge
            ? _c(_setup.LpuLoyaltyProgramBadge, {
                on: {
                  click: function ($event) {
                    _setup.isOpenedLpuLoyaltyProgramInfo = true
                  },
                },
              })
            : _c(_setup.LpuLoyaltyProgramPlate, {
                on: {
                  click: function ($event) {
                    _setup.isOpenedLpuLoyaltyProgramInfo = true
                  },
                },
              }),
          _vm._v(" "),
          _c(_setup.LpuLoyaltyProgramInfo, {
            attrs: {
              "bonus-levels": _vm.bonusLevels,
              "welcome-bonus-amount": _vm.welcomeBonusAmount,
              "max-payment-percent": _vm.maxPaymentPercent,
            },
            model: {
              value: _setup.isOpenedLpuLoyaltyProgramInfo,
              callback: function ($$v) {
                _setup.isOpenedLpuLoyaltyProgramInfo = $$v
              },
              expression: "isOpenedLpuLoyaltyProgramInfo",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }